import { mapActions } from 'vuex'
export default {
  data () {
    return {
      // 没有设置头像时的默认头像图片
      defaultImage: 'https://s3.moke.cloud/dianpei/eef71383-d33b-460d-a3b7-03ab9b3ebf4e.png',
      // 订单背景图片
      orderImage: 'https://s3.moke.cloud/dianpei/11e6ae7c-2e06-4bf7-a74c-e0b5c52e0bda.png',
      // 是否重新shelf
      isUpShelf: false
    }
  },
  computed: {
    // 判断是为苹果手机登录
    isIosStatus () {
      return this.$tkUa.isPlus && this.$tkUa.isIos
    },
    // 用户信息
    userInfo () {
      if (!this.$store.state || (this.$store.state && !this.$store.state.user)) return ''
      return this.$store.state.user
    },
    // 用户账号类别
    userCategory () {
      if (!this.$store.state.user) return null
      return this.$store.state.user.accountCategory
    },
    // 是否为终端账号用于判断价格显示
    isTerminalAccount () {
      return this.userCategory && this.userCategory === 'terminalAccount'
    },
    // 是否为厂家账号用于判断页面显示
    isFactoryAccount () {
      return this.userCategory && this.userCategory === 'factoryAccount'
    },
    // 是否为县代账号用于我的页面判断
    isCountyAccount () {
      return this.userCategory && this.userCategory === 'countyAccount'
    },
    // 县代账号下的用户级别
    levelName () {
      if (this.isCountyAccount) {
        return this.userInfo.membershipLevel ? this.userInfo.membershipLevel : 'registeredMember'
      }
      return 'registeredMember'
    },
    // 底部切换状态
    footerStatus () {
      return this.$store.state.toggleFooter
    }
  },
  methods: {
    ...mapActions(['updateUserMsg']),
    /**
    * 统计相关数量接口调用方法
    * @date: 2020/3/31
    */
    async statisticsNum (className, obj) {
      let countData = await this.$tkParse.get(`/classes/${className}`, {
        params: {
          count: 1,
          limit: 0,
          where: obj
        }
      })
      if (countData.data.count) { return countData.data.count } else { return 0 }
    },
    /**
    * 用于判断数据库有没有此数据
    * @date: 2020/3/31
    */
    async judgeId (id, path) {
      let judgeOrder = await this.$tkParse.getList(`/classes/${path}`, {
        params: {
          where: {
            objectId: id
          }
        }
      })
      return !!judgeOrder.length
    },
    /**
    * 设置状态栏文字颜色
    * @date: 2020/7/7
    */
    setStatusBar (color) {
      if (window.plus) { window.plus.navigator.setStatusBarStyle(color) }
    }
  }
}
